import { render, staticRenderFns } from "./TypePropertyDetailTable.vue?vue&type=template&id=4c0f1d4f"
import script from "./TypePropertyDetailTable.vue?vue&type=script&lang=js"
export * from "./TypePropertyDetailTable.vue?vue&type=script&lang=js"
import style0 from "./TypePropertyDetailTable.vue?vue&type=style&index=0&id=4c0f1d4f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports